"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
exports.instanceOfState = instanceOfState;
exports.StateFromJSON = StateFromJSON;
exports.StateFromJSONTyped = StateFromJSONTyped;
exports.StateToJSON = StateToJSON;
exports.StateToJSONTyped = StateToJSONTyped;
/**
 *
 * @export
 */
exports.State = {
    Al: 'AL',
    Ak: 'AK',
    Az: 'AZ',
    Ar: 'AR',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    De: 'DE',
    Dc: 'DC',
    Fl: 'FL',
    Ga: 'GA',
    Hi: 'HI',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ia: 'IA',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Me: 'ME',
    Md: 'MD',
    Ma: 'MA',
    Mi: 'MI',
    Mn: 'MN',
    Ms: 'MS',
    Mo: 'MO',
    Mt: 'MT',
    Ne: 'NE',
    Nv: 'NV',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Ny: 'NY',
    Nc: 'NC',
    Nd: 'ND',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Pr: 'PR',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Vt: 'VT',
    Va: 'VA',
    Wa: 'WA',
    Wv: 'WV',
    Wi: 'WI',
    Wy: 'WY'
};
function instanceOfState(value) {
    for (const key in exports.State) {
        if (Object.prototype.hasOwnProperty.call(exports.State, key)) {
            if (exports.State[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function StateFromJSON(json) {
    return StateFromJSONTyped(json, false);
}
function StateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StateToJSON(value) {
    return value;
}
function StateToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=State.js.map